export type Font = string;

enum Fonts {
  fontStyle = '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
}

export default Fonts;
